import { withVideoDetailContext } from 'shared/components/context/video-detail'
import VideoShareModal from '../../shared/modal/video-share'

// TODO fix `label` which is actually for reporting :/
const VideoDetailShareModal = ({ videoData }) => <VideoShareModal videoData={videoData} />

export default withVideoDetailContext()(VideoDetailShareModal)
